import QRCode from 'qrcode';
import { useEffect, useState } from 'react';

/**
 * Wie andere in diese Ausfahrt hineinkommen: QR-Code, Beitrittscode, Link.
 *
 * An zwei Stellen gebraucht — beim Anlegen und später aus der Kolonne heraus,
 * wenn unterwegs noch jemand dazustößt. Deshalb hier und nicht zweimal
 * hingeschrieben.
 *
 * Der QR-Code entsteht im Browser: Es gibt keinen Grund, dafür ein Bild über
 * die Leitung zu schicken, und erst recht keinen, dafür einen fremden Dienst
 * zu fragen — der wüsste dann, welche Ausfahrt gerade stattfindet.
 */

/** Die Adresse, unter der ein anderes Gerät der Ausfahrt beitritt. */
export function beitrittsUrl(joinCode: string): string {
  return `${window.location.origin}/beitreten/${joinCode}`;
}

/** Sechs Ziffern, in zwei Dreiergruppen — so wird eine Zahl vorgelesen. */
export function beitrittscodeLesbar(joinCode: string): string {
  return joinCode.replace(/(\d{3})(\d{3})/, '$1 $2');
}

export function Einladung({ joinCode, url }: { joinCode: string; url?: string }): React.JSX.Element {
  const ziel = url ?? beitrittsUrl(joinCode);
  const [bild, setBild] = useState<string | null>(null);

  useEffect(() => {
    /*
     * Als Bild und nicht als Canvas.
     *
     * `QRCode.toCanvas` schreibt die gewünschte Breite als Inline-Stil an das
     * Element, und der schlägt jede Regel aus dem Stylesheet. Auf dem iPhone
     * stand der Code deshalb 520 Pixel breit in einem 393 Pixel breiten
     * Fenster und war rechts abgeschnitten. Ein Bild bringt keine eigene Größe
     * mit; die Breite bestimmt allein `.qr`.
     *
     * Erzeugt wird er mit 1040 Pixeln und angezeigt mit höchstens 260 — auf
     * einem Bildschirm mit dreifacher Dichte bleibt er damit scharf.
     */
    let gültig = true;

    void QRCode.toDataURL(ziel, { width: 1040, margin: 1, errorCorrectionLevel: 'M' }).then(
      (erzeugt) => {
        if (gültig) {
          setBild(erzeugt);
        }
      },
      () => {
        // Ohne Bild bleiben Code und Link — beide stehen darunter, und mit
        // ihnen kommt man genauso hinein.
        if (gültig) {
          setBild(null);
        }
      },
    );

    return () => {
      gültig = false;
    };
  }, [ziel]);

  return (
    <>
      {bild !== null && <img className="qr" src={bild} alt="QR-Code zum Beitreten" />}
      <p className="code">{beitrittscodeLesbar(joinCode)}</p>
      <p className="datenschutz" style={{ textAlign: 'center', wordBreak: 'break-all' }}>
        {ziel}
      </p>
    </>
  );
}
